import { Button, Grid, GridItem } from "@chakra-ui/react";
import { React, useContext, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { context } from "@/context/valuationContext";

const Amenidades = ({ onOpen, isGreaterThanMd }) => {
    //Context
    const { addDataAmenities, step, updateStep, inCondo } = useContext(context);
    const [checkedItems, setCheckedItems] = useState([]);

    const amenities = [
        { key: 1, value: "Aire Acondicionado" },
        { key: 2, value: "Amueblado" },
        { key: 3, value: "Jacuzzi" },
        { key: 4, value: "Cocina Integral" },
        { key: 5, value: "Circuito Cerrado" },
        { key: 6, value: "Alberca" },
        { key: 7, value: "Terraza" },
        { key: 8, value: "Jardin" },
        { key: 9, value: "Lavanderia" },
        { key: 10, value: "GYM" },
        { key: 11, value: "Estudio" },
        { key: 12, value: "Calentador Solar" },
        { key: 13, value: "Casa Inteligente (Smart House)" },
        { key: 14, value: "Paneles Solares" },
        { key: 15, value: "Roof Garden" },
        { key: 16, value: "Cuarto Servicio" },
    ];

    const handleCheck = (e) => {
        let items_aux = [...checkedItems];
        if (checkedItems.find((items) => items === Number(e))) {
            items_aux.pop(Number(e));
        } else {
            items_aux.push(Number(e));
        }
        setCheckedItems(items_aux);
    };

    const handleSubmit = () => {
        addDataAmenities(checkedItems);
        if (inCondo) {
            updateStep(step + 1);
        } else {
            onOpen();
        }
    };
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            <Grid templateColumns="repeat(3, 1fr)" gap={4} alignItems="center" mt={2}>
                {amenities.map((amenity, index) => (
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 3}
                        textAlign="-webkit-left"
                        key={`amenity-${index}`}
                    >
                        <Checkbox
                            onChange={(e) => handleCheck(e.target.value)}
                            size="lg"
                            value={amenity.key}
                            colorPalette="yellow"
                            color="accent.500"
                        >
                            {amenity.value}
                        </Checkbox>
                    </GridItem>
                ))}
                <GridItem colSpan={3} textAlign="-webkit-right" mt={6}>
                    <Button
                        rounded="full"
                        colorPalette="brand"
                        bg="brand.500"
                        color="black"
                        border="0"
                        px="16"
                        _hover={{ bg: "brand.600" }}
                        type="submit"
                    >
                        Siguiente
                    </Button>
                </GridItem>
            </Grid>
        </form>
    );
};

export default Amenidades;
